import { IProfile } from "./profile.types"
export class Profile implements IProfile {
  displayName: string
  givenName: string
  surname: string
  jobTitle: string
  email: string
  mobilePhone: string
  officeLocation: string
  preferredLanguage: string
  userPrincipalName: string

  constructor(data: {
    displayName: string
    givenName: string
    surname: string
    jobTitle: string
    email: string
    mobilePhone: string
    officeLocation: string
    preferredLanguage: string
    userPrincipalName: string
  }) {
    this.displayName = data.displayName
    this.givenName = data.givenName
    this.surname = data.surname
    this.jobTitle = data.jobTitle
    this.email = data.email
    this.mobilePhone = data.mobilePhone
    this.officeLocation = data.officeLocation
    this.preferredLanguage = data.preferredLanguage
    this.userPrincipalName = data.userPrincipalName
  }
}
